import { trimBr } from "./Utils";
import {
  isBookRealTypeBible, isBookRealTypeBibleCommentaries,
  makeChapterTree as makeChapterTreeShared,
  makeParaDataFinal,
} from "@/shared/utils/content/content";
import { CONTENT_CLASSES, TREE_LABEL_HIDE_IN_TREE } from "@/shared/utils/content/content.constants";
import { highlightContainingMarkNoteElements } from "@/shared/utils/reader/reader-notes";

export const makeChapterTree = makeChapterTreeShared;

const externalRefRE = /href\s*=\s*['"]https?:\/\/[^\s]+['"]/gis;

const addBlankTarget = (string) => {
  const matches = string.match(externalRefRE);

  if (matches) {
    return string.replace(externalRefRE, `target="_blank" ${matches[0]}'`);
  }

  return string;
};

const DataLinkRegex = /data-link="(.*?)"/gm;

export const getAllDataLink = (paragraphs) => {
  let links = [];
  let resItem;
  paragraphs.forEach((item) => {
    const result = item.content.match(DataLinkRegex);
    result.forEach((matchResult) => {
      resItem = matchResult.split("\"")[1];
      if (!links.includes(resItem)) {
        links.push(resItem);
      }
    });
  });
  return links;
};

/**
 *
 * @param {Object[]} paras
 * @param {String} bookRealType
 * @param {*} bookType
 * @returns
 */
export const makeChapterContent = (paras, bookRealType, bookType) => {
  const isRealTypeBible = isBookRealTypeBible(bookRealType);
  const isRealTypeBibleCommentaries = isBookRealTypeBibleCommentaries(bookRealType);

  let htmlElement;
  const paragraphsParsed = paras.map((item, index) => {
    htmlElement = (!htmlElement || htmlElement.tagName !== item.element_type)
      ? document.createElement(item.element_type || "div")
      : htmlElement;
    const outPara = {
      ...item,
      id: item.para_id || item.id,
      bookType: bookRealType,
      className: CONTENT_CLASSES.PARAGRAPH,
    };
    outPara.content = addBlankTarget(outPara.content);

    const firstLinkIndex = outPara.content.indexOf(CONTENT_CLASSES.EGW_LINK);
    const isNeedParseLinks = firstLinkIndex > -1 && !outPara.links;

    // not needed parse again if make data from cache
    if (isNeedParseLinks || isRealTypeBible) {
      htmlElement.innerHTML = outPara.content;
      highlightContainingMarkNoteElements(htmlElement);

      if (isNeedParseLinks) {
        const allLinks = htmlElement.getElementsByClassName(CONTENT_CLASSES.EGW_LINK);
        let links = [];
        let icon;
        const linkClassName = CONTENT_CLASSES.ICON_BIBLE + " icon-bible";
        Array.from(allLinks).forEach((link) => {
          if (link.classList.contains(CONTENT_CLASSES.EGW_LINK_BIBLE)) {
            icon = `<i class="${linkClassName}" data-link="${link.dataset.link}"></i>`;
            if (!link.innerText) {
              link.classList.add("icon-link-empty");
              link.innerHTML = "<i class=\"icon-arrow-right \"></i>";
            }
            link.insertAdjacentHTML("afterend", icon);
            link.removeAttribute("title");
            links.push({ type: CONTENT_CLASSES.EGW_LINK_BIBLE, link: link.dataset.link });
          } else {
            links.push({ type: CONTENT_CLASSES.EGW_LINK, link: link.dataset.link });
          }
        });
        outPara.links = links;
      }

      // Removes bible verse number (bold text before paragraph),
      // It is needed for Bible Versions, because that bold text is generated manually there,
      // don't know about other types of bible.
      // – Skip removing for Bible Commentaries, because there is important content.
      if (isRealTypeBible && !isRealTypeBibleCommentaries) {
        htmlElement.querySelector("strong")?.remove();
      }
      // ============================

      outPara.content = htmlElement.innerHTML;
    }

    const paraDataFinal = makeParaDataFinal(bookType, bookRealType, outPara, index);

    outPara.label = paraDataFinal.labelFinal;
    outPara.treeLabel = paraDataFinal.labelTreeFinal;

    if (outPara.treeLabel === TREE_LABEL_HIDE_IN_TREE) {
      outPara.content = "";
    } else {
      outPara.content = trimBr(outPara.content);
    }

    return outPara;
  });

  if (htmlElement?.remove) {
    htmlElement.remove();
  }

  return paragraphsParsed;
};

export const cutOutHeaders = (dateContent) => {
  dateContent.forEach((item) => {
    item.content = item.content.filter((tag) => !tag.includes("</h1>"));
  });
  return dateContent;
};

export const normalizeSubsContent = (content) => {
  return content.map((item) => ({
    ...item,
    baseId: item.id,
    id: "sub" + item.id, //make special if for avoid endless tree rerender
    className: "subscription",
    label: item.book_title,
  }));
};
